import React, { Component } from 'react'
import moment from 'moment';

import { Input, InputGroup, Icon,CheckboxGroup,Checkbox,RadioGroup,Radio } from 'rsuite';

import Config from '../config/Config'
import Cache from '../frame/Cache';
import WidgetAjax from '../widget/WidgetAjax';
import WidgetMessage from '../widget/WidgetMessage';


import WidgetVertical from "../widget/WidgetVertical"
import WidgetBatch from "../widget/WidgetBatch"

import { Upload, message } from 'antd';
import { FileAddTwoTone } from '@ant-design/icons';

import TitleLeft from "../img/BusinessChance/TitleLeft.svg";
import LoadingTag from "../img/frame/loading.gif";
import "../css/marketing.css"
import "../css/BusinessChance.css";

import WidgetCondition from '../widget/WidgetCondition';

 class marketing extends Component 
 {

    constructor(){
        super();

        const { Dragger } = Upload;

        const setProps = {
            name: 'file',
            multiple: true,
            accept:".xls,.xlsx",
            onChange(info) {
                    const { status } = info.file;
                    if (status !== 'uploading') {
                        console.log(info.file, info.fileList);
                    }
                    if (status === 'done') {
                        message.success(`${info.file.name} file uploaded successfully.`);
                    } else if (status === 'error') {
                        message.error(`${info.file.name} file upload failed.`);
                    }
                },
            onDrop(e) {
                // console.log('Dropped files', e.dataTransfer.files);
            },
        };
        this.state = {
            basePath:Config.getBasePath(),
            Dragger,
            setProps,
            options : {
                // 数据条数
                records : 10
            },
            
            columns1:[
                { name: 'entid', title: '企业id', type: 'string', description: '企业id', properties: { hidden: true }},
                { name: 'inEntName', title: '合作企业', type: 'string', description: '合作企业', properties: { hidden: false }},
                { name: 'entName', title: '合作企业', type: 'string', description: '合作企业', properties: { hidden: false }},
                { name: 'relateType', title: '关联类型', type: 'string', description: '营销类型', properties: { hidden: false, transform: "transformRelateType"}},
                // { name: '"recommendation', title: '推荐度', type: 'string', description: '推荐度', properties: { hidden: false, transform: "transformRecommendation" }},
                { name: 'recommendation', title: '市场地位', type: 'string', description: '市场地位', properties: { hidden: false }},
                { name: 'industry', title: '行业类型', type: 'string', description: '行业类型', properties: { hidden: false }},
                { name: 'region', title: '所在地区', type: 'string', description: '所在地区', properties: { hidden: false }},
                { name: 'tel', title: '联系方式', type: 'string', description: '联系方式', properties: { hidden: false }},
                { name: 'entStatus', title: '企业状态', type: 'string', description: '企业状态', properties: { hidden: false, transform: "transformENTSTATUS" }},
                { name: 'operation', title: '操作', type: 'string', description: '操作', 
                    properties: {hidden: false, 
                        operations: [
                            { name: '添加监控', click: "marketingAddMonitor" },
                            { name: '添加CRM', click: "marketingAddCRM" }
                        ],
                        transform: "transformOperations"
                    }
                },
              
            ],
            data:[],
            // data1:undefined,
            data1:[
                
            ],
            thePage:true,
            change:false,
            isSingleQuery:true,
            information:true,
            maxText:"",
            lineNumber:0,
            skip:false,
            messageOptions: {
                title: '添加监管'
            },
            isSearchResultPage:false,
            keyWordFilterTypeData: [
                {
                    label: '包含所有',
                    value: '001',
                    type: "AND"
                },
                {
                    label: '包含任一',
                    value: '002',
                    type: "OR"
                }
            ],
            confirmKeyWords: [],
            fuzzySearchData:[],
            isFuzzySearchLoading:false,
            MfuzzySearchData:[],
            isFuzzySearch:false,
            fuzzySearchInputValue:"",
            timeout:null,
            entValue:undefined
        }
        this.checked = this.checked.bind(this);
        this.keyWordKeyUp = this.keyWordKeyUp.bind(this);
        this.onChangeTabular = this.onChangeTabular.bind(this);
        this.keyWordKeyUp = this.keyWordKeyUp.bind(this);
        this.tabular = this.tabular.bind(this);
        this.textareaChange = this.textareaChange.bind(this);
        this.notFound = this.notFound.bind(this);
        this.notFoundChange = this.notFoundChange.bind(this);
        this.offMask = this.offMask.bind(this);
        this.backMarKeting = this.backMarKeting.bind(this);


        this.transformOperations = this.transformOperations.bind(this);
        this.tableOnEvent = this.tableOnEvent.bind(this)
        // this.onTemplateDownload = this.onTemplateDownload.bind(this)

        this.export = this.export.bind(this);
        this.exportConfirm = this.exportConfirm.bind(this);
        this.onExport = this.onExport.bind(this);

        this.buildFilter = this.buildFilter.bind(this);
        this.findFilterType = this.findFilterType.bind(this);

        this.searchInput = this.searchInput.bind(this);
        this.clickFuzzySearch = this.clickFuzzySearch.bind(this);
        this.onFuzzySearch = this.onFuzzySearch.bind(this);
        this.onLoadFuzzySearch = this.onLoadFuzzySearch.bind(this);


    }
    

    setMessageRef = (ref) => {
        this.messageRef = ref;
    }
    //单条查询和多条查询切换函数
    checked(e,type)
    {
        this.setState({
            isSingleQuery:type
        })
    }
    /**
     * 键盘事件捕获
     * @param {*} e 
     */
    keyWordKeyUp( e )
    {
        /** 判断是否是回车事件 */
        if( e.keyCode === 13 )
        {
            this.onChangeTabular();
        }
    }

    /**
     * 单条搜索 搜索按钮点击事件
     */
    onChangeTabular()
    {
        let { information, data, fuzzySearchInputValue, messageOptions } = this.state;
        if( fuzzySearchInputValue.length > 0 )
        {
            if(data === undefined){
                this.setState({thePage:true,change:false,information:false,fuzzySearchInputValue:[]});
            }else{
                this.setState({thePage:true, change:true, isSearchResultPage:true,fuzzySearchInputValue:[]});
            }
            
        }
        else
        {
            messageOptions["isMessage"] = true;
            messageOptions["title"] = "搜索";
            messageOptions["message"] = "请先输入需要搜索的公司名称!";

            this.setState({messageOptions}, ()=>{
                this.messageRef.open()
            })
        }
    }

    /**
     * 多条查询 立即查看 的事件
     */
    tabular()
    {
        let { data1 } = this.state
        if(data1!==undefined){
            this.setState({thePage:false,change:true,skip:false,isSearchResultPage:true});

        }else{
            this.setState({skip:true})

        }
    }

    /**
     * 蒙层弹窗 重新提交、确认 按钮事件
     * @param {*} e 
     * @param {*} type 
     */

    notFound( e , type)
    {
        let { data1 } = this.state
        
            if(type==="determine"){
                if(data1 !== undefined){
                    this.setState({thePage:false,change:true,skip:false});

                }else{
                    this.setState({thePage:false,change:false,skip:true});

                }
            }else{
                this.setState({thePage:false,change:false,skip:true});
            }
        
    }

    /**
     * 多条查询输入框限制行数
     * @param {*} e 
     */
    textareaChange(e)
    {
        let text = e.target.value,
        rn = 0,
        { maxText } = this.state;

        if(text.length != 0)
        {
            rn = 1
        }
        else
        {
            rn = 0
        }

        for(let i=0 ; i<text.length ; i++)
        {
            if(text[i] === "\n")
            {
                rn++;
            }
        }
        
        if(rn  <= 2000)
        {
            this.setState({maxText:text,lineNumber:rn})
        }
        else
        {
            e.target.value = maxText
            // this.setState({lineNumber:rn})
        }
    }

    notFoundChange(e){
        if (e.keyCode === 13) {
            e.preventDefault() // 阻止浏览器默认换行操作
            return ;
        }
    }

     /**
     * 表格事件函数
     * @param {*} type 
     * @param {*} data 
     * @param {*} value 
     * @param {*} event 
     * @param {*} tableData
     * @returns 
     */
    tableOnEvent(type, data, value, event,tableData) 
    {
        switch (type) 
        {
            case "marketingAddMonitor":
            {
                data = JSON.parse(data);

                this.marketingAddMonitor(data);

                break;
            }
            case "marketingAddCRM":
            {
                data = JSON.parse(data);
                this.marketingAddCRM(data);
                break;
            }
            case "transformOperations":
            {
                return this.transformOperations(data, value);
            }
            default:
                break;
        }
    }

    /**
     * 操作格式化
     * @param {*} data 
     * @param {*} content 
     * @returns 
     */
     transformOperations(data, content) 
     {
         if (content.props !== undefined && content.props.children !== undefined) 
         {
             for (let i = 0; i < content.props.children.length; i++) 
             {
 
                 let child = content.props.children[i];
 
                 if (child.props.className === "marketingAddMonitor") 
                 {
                     if (data.MONITOR === true) {
                         content.props.children.splice(i, 1);
                         i--;
                     }
                 }
                 else if (child.props.className === "addCRM") 
                 {
                     if (data.CRM === true) 
                     {
                         content.props.children.splice(i, 1);
                         i--;
                     }
                 }
             }
         }
 
         return content;
     }


    /**
     * 关闭蒙层
     */
    offMask()
    {
         this.setState({skip:false})
    }   
    /**
     * 标题点击事件
     * 返回主页面
     */
    backMarKeting()
    {
         this.setState({change:false,isSearchResultPage:false,isFuzzySearch:false})
    }   
    /**
     * 导出按钮
     */
    export( )
    {
        let { messageOptions, checkData}=this.state;
    
        messageOptions["isMessage"] = false ;
    
        if( checkData!==undefined && checkData!==null && checkData.length>0 )
        {
             messageOptions["message"] = `确定要导出当前选中的 ` + checkData.length + ` 记录吗?`;
        }
         else
         {
             messageOptions["message"] = `确定要下载模板数据吗?`;
         }      
         messageOptions['confirmFunction'] = this.exportConfirm;
     
         messageOptions["title"] = "导出确认" ;

         this.state['messageOptions'] = messageOptions;     
         this.messageRef.open(); 
     }

    exportConfirm()
    {
        const { basePath, checkData, filterTypeValue} = this.state;

        let filters = {}, filterType = "ALL" ;

        if( checkData!==undefined && checkData.length>0 )
        {
            let isFirst = true, content = "";
            for(let item of checkData )
            {
                if( isFirst )
                {
                    content = "'"+item.ENTID+"'";
                    isFirst = false;
                }
                else
                {
                    content += ",'" + item.ENTID +"'";
                }

            }

            filters["ENTID"] = "${ENTID} IN ("+content+")";
        }
        else
        {
            filters = this.buildFilter();

            if ( filterTypeValue==="ANY" ) 
            {
                filterType = "ANY";
            }
        }


        let params = {
            schema: "T001001",
            filters: filters,
            filterType: filterType
        }

        WidgetAjax.ajax({url:basePath + '/report/excel', params:params, callback:this.onExport}); 
    }

    onExport( result, params )
    {        
        const { basePath, messageOptions } = this.state;

        let fileName = "export.xlsx";

        if( result.status===0 )
        {
            let token = result.token;

            let url = basePath + "/report/download";

            WidgetAjax.exportFile({ url:url, params:{token:token, fileName:fileName} });

        }
        else if( result.status===10 )
        {
            Cache.logout(this.props.parentProps);
        }
        else
        {
            messageOptions["isMessage"] = true ;

            messageOptions["message"] = '数据导出失败!' ;

            messageOptions["title"] = "数据导出" ;

            this.state['messageOptions'] = messageOptions;

            this.messageRef.open();
        }
    }


    /**
     * 构建 filter
     */
     buildFilter() 
     {
         let { confirmValues, confirmConditions, confirmKeyWords, keyWordRangeData, attributes, keyWordFilterType, confirmMapConditions} = this.state, filters = {};
 
         const widgetCondition = new WidgetCondition();
 
         //条件筛选
         if (attributes !== undefined && attributes !== null && attributes.length > 0) 
         {
             for (let attribute of attributes) 
             {
                 let expression, key = attribute.name;
 
                 if (attribute.type === "DIMENSION") 
                 {
                     key = attribute.content.code;
                 }
 
                 if (confirmConditions[key] !== undefined && confirmConditions[key] !== null) 
                 {
                     switch (attribute.type) 
                     {
                         case "STRING":
                         {
                             if (attribute.index === "TEXT") 
                             {
                                 expression = "${" + key + "} has '" + confirmConditions[key] + "'";
                             }
                             else 
                             {
                                 expression = "${" + key + "} = '" + confirmConditions[key] + "'";
                             }
 
                             filters[key] = expression;
                             break;
                         }
                         case "DATE":
                         case "NUMBER":
                         case "INTEGER":
                         {
                             if (key === "ESTDATE") 
                             {
                                 if (confirmConditions[key].start !== undefined && confirmConditions[key].start !== "") 
                                 {
                                     let startValue = moment(moment(confirmConditions[key].start, 'YYYYMMDD')).format('YYYY-MM-DD');
 
                                     if (confirmConditions[key].end !== undefined && confirmConditions[key].end !== "") 
                                     {
                                         let endValue = moment(moment(confirmConditions[key].end, 'YYYYMMDD')).format('YYYY-MM-DD');
 
                                         expression = widgetCondition.createCondition(key, "range",
                                             { min: { code: key, operator: 'BE', value: startValue }, max: { code: key, operator: 'SE', value: endValue } });
                                     }
                                     else 
                                     {
                                         expression = '${' + key + '} >= ' + confirmConditions[key].start;
                                     }
                                 }
                                 else 
                                 {
                                     if (confirmConditions[key].end !== undefined && confirmConditions[key].end !== "")
                                      {
                                         let endValue = moment(moment(confirmConditions[key].end, 'YYYYMMDD')).format('YYYY-MM-DD');
 
                                         expression = '${' + key + '} <= ' + endValue;
                                     }
                                     else 
                                     {
                                         expression = undefined;
                                     }
                                 }
                             }
                             else 
                             {
                                 if (confirmConditions[key].start !== undefined && confirmConditions[key].start !== "") 
                                 {
                                     if (confirmConditions[key].end !== undefined && confirmConditions[key].end !== "") 
                                     {
                                         expression = widgetCondition.createCondition(key, "range",
                                             { min: { code: key, operator: 'BE', value: confirmConditions[key].start }, max: { code: key, operator: 'SE', value: confirmConditions[key].end } });
                                     }
                                     else 
                                     {
                                         expression = '${' + key + '} >= ' + confirmConditions[key].start;
                                     }
                                 }
                                 else 
                                 {
                                     if (confirmConditions[key].end !== undefined && confirmConditions[key].end !== "")
                                     {
                                         expression = '${' + key + '} <= ' + confirmConditions[key].end;
                                     }
                                     else 
                                     {
                                         expression = undefined;
                                     }
                                 }
                             }
 
                             filters[key] = expression;
 
                             break;
                         }
                         case "NOMINAL":
                         {
                             if (confirmConditions[key] !== undefined) 
                             {
                                 let expression = widgetCondition.createCondition(key, "point", { code: key, operator: "E", value: confirmConditions[key] });
 
                                 filters[key] = expression;
                             }
                             else {
                                 filters[key] = undefined;
                             }
                             break;
                         }
                         case "DIMENSION":
                         {
 
                             key = attribute.content.code;
 
                             if (attribute.index === "SINGLE") 
                             {
                                 if (confirmConditions[key] !== undefined && confirmConditions[key] !== null) 
                                 {
                                     let item = confirmConditions[key];
 
                                     let code = attribute.content.code;
 
                                     expression = widgetCondition.createCondition(item.code, "point", { code: item.code, operator: "E", value: item.value });
 
                                     filters[code] = expression;
 
                                 }
                             }
                             else 
                             {
                                 if( confirmConditions[key]!==undefined && confirmConditions[key]!==null ) 
                                 {
                                     let treeConditions = confirmConditions[key], params = [];
 
                                     for( let code in treeConditions) 
                                     {
                                         let set = [];
                                         for (let item of treeConditions[code]) 
                                         {
                                             set.push(item.value);
                                         }
                                         params.push({ code: code, operator: 'IN', set: set });
                                     }
 
                                     if( params.length > 0) 
                                     {
                                         expression = widgetCondition.createCondition(attribute.content.code, "composite", params);
                                     }
 
                                     filters[attribute.content.code.substring(0, 4)] = expression;
 
                                 }
                             }
                         }
                     }
                 }
             }
         }
 
         // 标签  filter
         for( let i in confirmValues ) 
         {
             let flag = true, key, expression;
 
             for (let j in confirmValues[i]) 
             {
                 if (flag) 
                 {
                     flag = !flag;
                     key = confirmValues[i][j].type;
                     expression = widgetCondition.createCondition(confirmValues[i][j].type, "point", { code: confirmValues[i][j].type, operator: "E", value: confirmValues[i][j].value });
                 }
                 else 
                 {
                     expression += " OR " + widgetCondition.createCondition(confirmValues[i][j].type, "point", { code: confirmValues[i][j].type, operator: "E", value: confirmValues[i][j].value });
                 }
             }
 
             filters[key] = expression;
         }
 
         // 关键词 filter
         let keyWordFilterTypeItem = this.findFilterType(keyWordFilterType);
 
         if (confirmKeyWords.length > 0 && keyWordRangeData.length > 0) 
         {
             if (keyWordFilterTypeItem.type === "OR") 
             {
                 let keyFlag = true, expresFlag = true, key, expression;
 
                 for (let i in keyWordRangeData) 
                 {
                     if (keyFlag) 
                     {
                         keyFlag = !keyFlag;
 
                         key = keyWordRangeData[i].name;
                     }
                     else 
                     {
                         key += "|" + keyWordRangeData[i].name;
                     }
 
                     for (let j in confirmKeyWords) 
                     {
                         if (expresFlag) 
                         {
                             expresFlag = !expresFlag;
 
                             expression = "${" + keyWordRangeData[i].name + "} has '" + confirmKeyWords[j] + "'";
                         }
                         else 
                         {
                             expression += " OR " + "${" + keyWordRangeData[i].name + "} has '" + confirmKeyWords[j] + "'";
                         }
                     }
                 }
 
                 filters[key] = expression;
 
             }
             else if (keyWordFilterTypeItem.type === "AND") 
             {
                 for (let i in keyWordRangeData) 
                 {
                     let key = keyWordRangeData[i].name, expression, flag = true;
 
                     for (let j in confirmKeyWords) 
                     {
                         if (flag) 
                         {
                             flag = !flag;
 
                             expression = "${" + keyWordRangeData[i].name + "} has '" + confirmKeyWords[j] + "'";
                         }
                         else 
                         {
                             expression += " OR " + "${" + keyWordRangeData[i].name + "} has '" + confirmKeyWords[j] + "'";
                         }
                     }
 
                     filters[key] = expression;
                 }
             }
         }
 
 
         // POI 条件
         if( confirmMapConditions!==undefined && confirmMapConditions!==null && Object.keys(confirmMapConditions).length>0 )
         {
             if( confirmMapConditions.hasOwnProperty("mapType"))
             {
                 let expression;
                  
                 switch( confirmMapConditions.mapType )
                 {
                     case "range":
                     {
                         if( confirmMapConditions.circleCenter!==undefined && confirmMapConditions.circleRadius!==undefined )
                         {
                             let radius = confirmMapConditions.circleRadius.value/1000;
                             let center = confirmMapConditions.circleCenter;
 
                             expression = "${LOCATION} GDCIN ('["+center.coordinate[0]+","+center.coordinate[1]+"]', '"+radius+"km')";
                         }
                         break;
                     }
                     case "circle":
                     {
                         let radius = confirmMapConditions["radius"]/1000;
                         let center = confirmMapConditions["center"];
 
                         expression = "${LOCATION} GDCIN ('[" + center[0] + "," + center[1] + "]', '" + radius + "km')";
 
                         break;
                     }
                     case "rectangle":
                     {
                         let points = confirmMapConditions["points"];
 
                         let lnglats = "", isFirst = true;
 
                         for(let i=0; i<points.length; i++ )
                         {
                             let point = points[i];
 
                             if( i===0 || i===2 )
                             {
                                 if( isFirst )
                                 {
                                     lnglats = "'[" + point[0] + "," + point[1] +"]'";
                                     isFirst = false;
                                     
                                 }
                                 else
                                 {
                                     lnglats += ", " + "'[" + point[0] + "," + point[1] +"]'";
                                 }
                             }
                         }
 
                         expression = "${LOCATION} GBXIN (" + lnglats + ")";
                         break;
                     }
                     case "polygon":
                     {
                         let points = confirmMapConditions["points"];
 
                         let lnglats = "", isFirst = true;
 
                         for(let point of points )
                         {
                             if( isFirst )
                             {
                                 lnglats = "'[" + point[0] + "," + point[1] +"]'";
                                 isFirst = false;
                                 
                             }
                             else
                             {
                                 lnglats += ", " + "'[" + point[0] + "," + point[1] +"]'";
                             }
                         }
 
                         expression = "${LOCATION} GPYIN (" + lnglats + ")";
 
                         break;
                     }
                     default :
                         expression = undefined;
                         break;
                     
                 }
 
                 if( expression!==undefined )
                 {
                     filters["LOCATION"] = expression;
                 }
 
             }
 
             if( confirmMapConditions.hasOwnProperty("D150001"))
             {
                 let treeConditions = confirmMapConditions["D150001"], params = [], expression;
 
                 for( let code in treeConditions) 
                 {
                     let set = [];
 
                     for (let item of treeConditions[code]) 
                     {
                         set.push(item.value);
                     }
                     params.push({ code: code, operator: 'IN', set: set });
                 }
 
                 if( params.length>0) 
                 {
                     expression = widgetCondition.createCondition("D150001", "composite", params);
 
                     filters["D150001".substring(0, 4)] = expression;
                 }
             }
         }
 
         return filters;
     }

     /**
     * 查找关键字筛选条件类型
     * @param {*} value 
     * @returns 
     */
    findFilterType(value) 
    {
        const { keyWordFilterType, keyWordFilterTypeData } = this.state;

        if (value === undefined) value = keyWordFilterType;

        for (let item of keyWordFilterTypeData) {
            if (item.value === value)

                return item;
        }
    }

    searchInput( e )
    {
        let { MfuzzySearchData, timeout,entValue } = this.state,
            value = e.target.value;
            let filter = /[\u4E00-\u9FA5\uF900-\uFA2D]{1,}/;
        // if( filter.test(value))
        if( value.length > 0 )
        {
            clearTimeout(timeout)
            this.setState({
                isFuzzySearch:true,
                isFuzzySearchLoading:false,
                entValue:value
            }, ()=>{
                timeout = setTimeout(()=>{
                    this.onFuzzySearch( value )
                }, 1500)
                this.setState({timeout})
            })
        }
        else 
        {
            clearTimeout(timeout)
            this.setState({
                isFuzzySearch:false
            })
        }

        this.setState({
            fuzzySearchInputValue:value,
            entValue:value
        })
    }

    onFuzzySearch( value )
    {
        let { basePath } = this.state;
        
        let params = {ENTNAME:value}

        WidgetAjax.ajax({url:basePath + '/entity/vague_search', params:params, callback:this.onLoadFuzzySearch});
    }

    onLoadFuzzySearch( result )
    {
        if (result.status === 0) 
        {
            this.setState({fuzzySearchData:result.results, isFuzzySearchLoading:true});
        }
        else if (result.status === 10) 
        {
            Cache.logout(this.props);
        }
    }

    clickFuzzySearch( value )
    {
        this.setState({
            fuzzySearchInputValue:value.entname,
            isFuzzySearch:false,
            entValue:value.entname
        })
    }

    render() {
        const { setProps, Dragger, columns, columns1, options, data, data1, thePage, change, isSingleQuery, 
                information, lineNumber, skip, messageOptions, isSearchResultPage, isFuzzySearch, fuzzySearchData,entValue,
                fuzzySearchInputValue, isFuzzySearchLoading } = this.state;
        return (
            <div className="page marketing overflow-auto">
                <div className="marketing-top">
                    <img src={TitleLeft}/>
                    <span className={isSearchResultPage?'click hoverColor':""} 
                          onClick={isSearchResultPage?this.backMarKeting:null}
                          style={{marginLeft:"10px"}}>
                        
                        <p>{"营销关系"}</p>
                    </span>
                    <span style={isSearchResultPage?{display:"block"}:{display:"none"}}> <span style={{margin:"5px"}}>&gt;</span>{entValue}</span>
                </div>
                <div className="marketing-center" style={change?{display:"none"}:{display:"block"}}>
                    <div className='marketingLabel-style click' onClick={(e)=>this.checked(e,true)}>
                        <div className={isSingleQuery?'likeRadio likeRadio_active':'likeRadio'}>
                            {isSingleQuery?<div className='likeRadioSon'></div>:null}
                        </div>
                        <span>单条查询</span>
                    </div>
                    <div className='marketingLabel-style click' onClick={(e)=>this.checked(e,false)}>
                        <div className={isSingleQuery?'likeRadio':'likeRadio likeRadio_active'}>
                            {isSingleQuery?null:<div className='likeRadioSon'></div>}
                        </div>
                        <span>批量查询</span>
                    </div>
                </div>
                <div className="marketing-bottom" style={change?{display:"none"}:{display:"block"}}  >

                    {/* 单条查询 */}
                    <div className="vertical-inquire" style={isSingleQuery?{display:"block"}:{display:"none"}}>
                        <div className="vertical-search" >
                                <input type="text" placeholder="请输入企业名称" value={fuzzySearchInputValue} onChange={this.searchInput}
                                onKeyUp={this.keyWordKeyUp} 
                                />
                                <div className='fuzzySearch' style={isFuzzySearch? {display:"block"}:{display:"none"}}>
                                    {
                                        isFuzzySearchLoading ?
                                        fuzzySearchData.length === 0 || fuzzySearchData[0] == null?
                                        <div> { `未找到包含 “${fuzzySearchInputValue}” 关键词的公司` } </div>:
                                        fuzzySearchData.map((val,index)=>{
                                            if( val!==null && val!==undefined && val!=="" )
                                            {
                                                return <div key={index} className='click' onClick={()=>{this.clickFuzzySearch(val)}}>{val.entname}</div>
                                            }
                                        })
                                        :
                                        <img className="loading-marketing" src={LoadingTag} />
                                    }
                                </div>
                            <span className="vertical-button click" onClick={this.onChangeTabular}>搜索</span>
                        </div>
                        {information?
                            <div className="vertical-text">请输入需要查询的企业</div>
                        :
                            <div className="vertical-text">未查询到该企业信息</div>
                        }
                        
                    </div>

                    {/* 多条查询 */}
                    <div className="batch-inquire" style={isSingleQuery?{display:"none"}:{display:"block"}}>
                        <div className="h3" ><h3>请上传企业信息</h3></div>

                        <div className="batch-inquire-center">
                            <div>
                                <p className='uploadTitle-style'>查询方法一:上传文档</p>
                                {/* <textarea rows="3" cols="20" placeholder="" /> */}
                                <Dragger {...setProps} 
                                         width={"20px"} 
                                         showUploadList={false}
                                         accept='.xls,.xlsx' >
                                    <p className="ant-upload-drag-icon">
                                    <FileAddTwoTone />
                                    </p>
                                    <p className="ant-upload-text">将文件拖拽到这里上传</p>
                                    <p className="ant-upload-hint">支持扩展名:xls，xlsx</p>
                                </Dragger>
                                <p className='templateDownload click' onClick={this.export}>模板下载</p>
                            </div>
                            <div className='searchTwo'>
                                <p>查询方法二:粘贴文档</p>
                                <textarea onChange={(e)=>{this.textareaChange(e)}} placeholder={`例如:\n中国农业银行股份有限公司\n中国银行股份有限公司`} />
                                <div className="batch-inquire-center-font">
                                    <p className='lineNumber-style' style={{textAlign:"center",color:lineNumber == 2000?"red":""}}><span>{lineNumber}</span>/2000</p>
                                    <p style={{background:"#016EFF",textAlign:"center",color:"#ffffff",fontSize:"14px",cursor:"pointer"}} onClick={this.tabular}>立即查询</p>
                                </div>
                                {lineNumber === 2000?<p className='lineNumberMax'>已达到输入行数上限</p>:null}
                            </div>
                            
                        </div>

                        <div className="batch-inquire-bottom">
                            <div>
                                <span>1.下载模板病填充企业名录信息；</span>
                                <span>2.上传文件不超过300KB，仅支持Excel(xls、xlsx)文件；</span>
                                <span>3.单次查询企业不能超过2000家；</span>
                            </div>
                            <div>
                                <span>1.单次查询不能超过2000行；</span>
                                <span>2.每行仅支持输入一个公司名称；</span>
                            </div>
                        </div>
                    </div>

                </div>
                <div style={change?{display:"block",marginTop:"10px"}:{display:"none"}}>
                        {thePage?
                            <WidgetVertical options={options} searchInputValue={fuzzySearchInputValue} entValue={entValue}
                                tableOnEvent={this.tableOnEvent} backMarKeting={this.backMarKeting} />
                        :
                             <WidgetBatch options={options} searchInputValue={fuzzySearchInputValue} entValue={entValue}
                                tableOnEvent={this.tableOnEvent} backMarKeting={this.backMarKeting} />
                        }
                </div>
                <div className='notFound_mark'style={skip?{display:"block"}:{display:"none"}}>
                    <div className="notFound">
                        <p className='offMask click' onClick={this.offMask} title='关闭提示'>
                            {"x"}
                        </p>
                        <p className='maskTitle'>未查询到下列企业交易信息</p>
                        <textarea className="textarea" rows={7} cols="20"onChange={(e)=>{this.notFoundChange(e)}}  />
                        <div className="notFound-bottom">
                            <button className="resubmit" onClick={(e)=>this.notFound(e,"resubmit")}>重新提交</button>
                            <button className="determine"  onClick={(e)=>this.notFound(e,"determine")}>确定</button>
                        </div>
                    </div>
                </div>
                <WidgetMessage options={messageOptions} onRef={this.setMessageRef} />
            </div>
        )
    }
}

export default marketing
